import type { FC } from "react";

import { makeBreakpointClassName } from "@/ui/lib/utils";
import {
  BASE_TEXT_BODY_SIZE_CLASS_MAP,
  RESPONSIVE_TEXT_BODY_SIZE_CLASS_MAP,
  TEXT_BODY_DEFAULTS,
  TTextBodyProps,
} from "@/ui/components/typography/TextBody/TextBody.config";
import {
  TYPOGRAPHY_COLORS_CLASS_MAP,
  TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP,
  TYPOGRAPHY_WEIGHTS_CLASS_MAP,
  TYPOGRAPHY_WHITESPACES_CLASS_MAP,
} from "@/ui/components/typography/typography.config";
import { clsx } from "clsx";

export const TextBody: FC<TTextBodyProps> = (
  {
    tag: Tag = TEXT_BODY_DEFAULTS.tag,
    size = TEXT_BODY_DEFAULTS.size,
    color = TEXT_BODY_DEFAULTS.color,
    align = TEXT_BODY_DEFAULTS.align,
    whitespace = TEXT_BODY_DEFAULTS.whitespace,
    isResponsive = TEXT_BODY_DEFAULTS.isResponsive,
    weight = TEXT_BODY_DEFAULTS.weight,
    children,
    className,
    ...props
  },
) => (
  <Tag
    {...props}
    data-component="TextBody"
    className={clsx(
      makeBreakpointClassName(align, TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP, "left"),
      TYPOGRAPHY_WHITESPACES_CLASS_MAP[whitespace],
      TYPOGRAPHY_COLORS_CLASS_MAP[color],
      TYPOGRAPHY_WEIGHTS_CLASS_MAP[weight],
      "font-sys-default",
      isResponsive ?
        RESPONSIVE_TEXT_BODY_SIZE_CLASS_MAP[size] :
        BASE_TEXT_BODY_SIZE_CLASS_MAP[size],
      className,
    )
    }
  >
    { children }
  </Tag>
);

TextBody.displayName = "TextBody";
